










































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import moment from 'moment'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component
export default class ComponentErrosValidacao extends Vue {
  get modalErrosValidacao() { return this.getFinanceiroStore.modal.errosValidacao }
  set modalErrosValidacao(value: boolean) { this.getFinanceiroStore.setModal({ name: 'errosValidacao', value }) }

  get validacaoRepasseErrosHeader() { return this.getFinanceiroStore.validacaoRepasseErrosHeader }

  get validacaoErros() { return this.getFinanceiroStore.validacaoErros }

  formatDateTimeUtil(date: string) {
    if (['', null, undefined].includes(date)) return 'Não informado'
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }
}
